var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var defaultFormatNumberToPrecisionOptions = {
  preserveWholeNumbers: true,
  valueIfEmpty: '-'
};
export var formatNumberToPrecision = function (value, precision, options) {
  var opts = __assign(__assign({}, defaultFormatNumberToPrecisionOptions), options || {});
  if (!value) {
    return opts.valueIfEmpty;
  }
  return value % 1 === 0 && opts.preserveWholeNumbers ? value.toFixed(0) : value.toFixed(precision);
};